import { Injectable, Injector } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';
import { AuthService } from '@ipreo/northstar';
import {
  SessionActionTypes,
  LoadSessionSuccess
} from '../state/session/actions';
import {
  UserDetailsTypes,
  LoadCurrentUserSuccess,
  LoadBranchesSuccess
} from '../state/global/user-details-api/actions';
import _ from 'lodash';
import { UserBranchDetailsApiDto } from '../state/global/user-details-api/models/user-branch-details-api-dto';

@Injectable()
export class PendoService {
  constructor(
    private actions$: Actions,
    private injector: Injector
  ) {
    console.log('PendoService initialized');
  }

  /**
   * Initialize Pendo with all required data after all 3 success actions fire
   * Listens for: LoadSessionSuccess, LoadCurrentUserSuccess, LoadBranchesSuccess
   */
  public initializePendo(): void {
    // Listen to all 3 success actions
    combineLatest([
      this.actions$.pipe(ofType(SessionActionTypes.LoadSuccess)),
      this.actions$.pipe(ofType(UserDetailsTypes.LoadCurrentUserSuccess)),
      this.actions$.pipe(ofType(UserDetailsTypes.LoadBranchesSuccess))
    ])
      .pipe(take(1))
      .subscribe(
        ([sessionAction, userAction, branchesAction]: [
          LoadSessionSuccess,
          LoadCurrentUserSuccess,
          LoadBranchesSuccess
        ]) => {
          const pendo = window['pendo'];
          if (!pendo) {
            console.warn('Pendo SDK not available');
            return;
          }

          try {
            const auth = this.injector.get(AuthService);
            const userId = _.get(auth, 'currentUser.profile.sub');

            // Get data directly from action payloads
            const session = sessionAction.payload;
            const currentUser = userAction.currentUser;
            const branches = branchesAction.payload;

            // Find the selected branch's long name
            const branchLongName = this.getBranchLongName(
              branches,
              currentUser?.customerId
            );

            // Send all data to Pendo
            const { deptId, deptType, firmId, persona } = session || {};
            const pendoData = {
              visitor: {
                id: userId
              },
              account: {
                id: deptId,
                dept_id: deptId,
                dept_type: deptType,
                firm_id: firmId,
                persona: persona,
                branch_long_name: branchLongName,
                underwriter: currentUser?.underWriter
              }
            };

            pendo.updateOptions(pendoData);
            console.log('Pendo initialized successfully');
          } catch (error) {
            console.error('Error initializing Pendo:', error);
          }
        }
      );
  }

  private getBranchLongName(
    branches: UserBranchDetailsApiDto[],
    selectedBranchId: string
  ) {
    if (branches && selectedBranchId) {
      return branches.find((branch) => branch.customerId === selectedBranchId)
        ?.longName;
    }
    return null;
  }
}
